import { render, staticRenderFns } from "./ShareView.vue?vue&type=template&id=06a5c95a&"
import script from "./ShareView.vue?vue&type=script&lang=ts&"
export * from "./ShareView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports